import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule, LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeKo from '@angular/common/locales/ko';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

registerLocaleData(localeKo);
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpClientService } from './service/http-client.service';

import { NavigationComponent } from './navigation/navigation.component';
import { ProgressSpinnerModule } from './common/progress/progress-spinner.module';
import { MaterialModule } from './material-module';
import { MenuButtonModule } from './navigation/menu-button/menu-button.module';
import { BreadcrumbModule } from './common/component/breadcrumb/breadcrumb.module';
import { ErrorPageComponent } from './error-page/error-page.component';
import { UserListDialogComponent } from './user/user-management/components/user-list-dialog/user-list-dialog.component';

@NgModule({
  declarations: [
    AppComponent,
    NavigationComponent,
    UserListDialogComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CommonModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MaterialModule,
    MenuButtonModule,
    ProgressSpinnerModule,
    BreadcrumbModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HttpClientService, multi: true },
    { provide: ErrorHandler, useClass: HttpClientService },
    { provide: LOCALE_ID, useValue: 'ko-KR' },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
